import { render, staticRenderFns } from "./AudienceListItem.vue?vue&type=template&id=85939612"
import script from "./AudienceListItem.vue?vue&type=script&lang=js"
export * from "./AudienceListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports